import helperFunctions from '@/utils/helperFunctions';
import { AVAnalyticsEventNames } from '@/utils/enums';

const toWatch = ['analytics/AV_ANALYTICS_EVENT'];

export default store => {
  store.subscribe((mutation, rootState) => {
    if (toWatch.includes(mutation.type)) {
      // ---- COAG events
      // These are custom post message events built for COAG (CanadaOne Auto Group)
      // for their internal use of adobe analytics
      // https://mobials.atlassian.net/browse/DR-497
      // https://mobials.atlassian.net/wiki/spaces/TKB/pages/2585722915/Updated+event+structure
      // we only send them form start and form complete events
      if (
        mutation.payload.name === AVAnalyticsEventNames.FORM_START ||
        mutation.payload.name === AVAnalyticsEventNames.FORM_COMPLETE
      ) {
        try {
          let referrerUrl = decodeURIComponent(rootState.route.query.referrer_url);
          // check if referrerUrl is encoded in base64 as it is like that sometimes.
          try {
            referrerUrl = window.atob(referrerUrl);
          } catch (e) {
            // failed so its not base64 encoded, do nothing
          }

          const message = {
            target: 'AutoVerifyAnalytics',
            iframePageUrl: referrerUrl,
            formName: mutation.payload.formName,
            eventName: mutation.payload.name,
          };

          // Add vehicle data only if we have it
          if (rootState.vehicle.vehicleInfo && rootState.vehicle.vehicleInfo.year) {
            message.vehicle = rootState.vehicle.vehicleInfo;
          }

          window.parent.postMessage([message], '*');
        } catch (error) {
          store._vm.$log(
            `Error inside AV analytics subscriber, business api key: ${JSON.stringify(rootState.business.api)}`,
            error
          );
        }
      }
      if (!mutation.payload.isCOAGOnlyEvent) {
        // ---- ASC events
        try {
          const event = helperFunctions.generateASCEventPayload(mutation.payload, rootState.route.query.vin);
          if (event) {
            window.parent.postMessage(event, '*');
            // Whenever we fire asc_form_submission, we need to send a second event to ASC
            // with the same data but with a different event name based on the current form
            if (event.event_name === 'asc_form_submission') {
              const event2 = event;
              event2.event_name =
                event.event_data.form_name === 'Test Drive - Request submitted'
                  ? 'asc_form_submission_sales_appt'
                  : 'asc_form_submission_sales';
              window.parent.postMessage(event2, '*');
            }
          }
        } catch (e) {
          store._vm.$log(
            `Error inside AV analytics subscriber ASC event, business api key: ${JSON.stringify(
              rootState.business.api
            )}`,
            e
          );
        }
      }
    }
  });
};
